<template>
    <p class="paragraph">
        {{text}}
    </p>
</template>

<script>
export default {
  name: 'paragraph',
  props: ['text']
}
</script>

<style lang="scss">
.paragraph {
    text-align: left;
    margin: 0;
    font-size: rem(14px);
    line-height: rem(24px);
    color: color(grey-dark);
    padding-top: rem(10px);
    min-width: rem(260px);
}
</style>
